import script from "./MisUsos.vue?vue&type=script&setup=true&lang=js"
export * from "./MisUsos.vue?vue&type=script&setup=true&lang=js"

import "./MisUsos.vue?vue&type=style&index=0&id=6a174efe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a174efe"]])

export default __exports__